import { CUSTOM_PDF_REPORTS_LIST_STATE_KEYS } from 'CustomPDFReportsApp/ts/apps/custom-pdf-reports-list-app/state/constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { getListPageRedirectUrl } from 'AccountsApp/ts/utils/utils';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "NewAngular/services/core/ajax.service";
import * as i3 from "NewAngular/services/core/urls.service";
export class CustomPDFReportService {
    constructor(accountsService, ajaxService, urlsService) {
        this.accountsService = accountsService;
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    async getCustomPDFReportsListPageRedirectUrl(overrides) {
        return getListPageRedirectUrl(this.accountsService, this.urlsService.CUSTOM_PDF_REPORTS.LIST_PAGE, 'custom_pdf_reports_list_page', CUSTOM_PDF_REPORTS_LIST_STATE_KEYS, overrides);
    }
    getGenerateReports(params) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.GENERATE_COLLECTION;
        const queryParams = formFlattenedObject(params, [
            'dataSource',
            'name',
            'owner',
            'reportType',
            'language',
            'baseResourceType',
            'sortColumn',
            'sortDirection',
        ]);
        // Add optional parameters only if they exist
        if (params.securityId) {
            queryParams.securityId = params.securityId;
        }
        if (params.securitylistName) {
            queryParams.securitylistName = params.securitylistName;
        }
        return this.ajaxService.getDataObserveBody(url, queryParams);
    }
    getGenerateReportInfo(reportId, baseResourceType) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.GENERATE_REPORT_MODAL, { reportId });
        const params = baseResourceType ? { baseResourceType } : {};
        return this.ajaxService.getDataObserveBody(url, params);
    }
    getTearsheetPDFReports(reportType, reportOrientation) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.TEARSHEET_COLLECTION;
        return this.ajaxService.getDataObserveBody(url, { reportType, reportOrientation });
    }
    getModalPDFReports(reportOrientation) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.MODAL_COLLECTION;
        if (reportOrientation) {
            return this.ajaxService.getDataObserveBody(url, { reportOrientation });
        }
        return this.ajaxService.getDataObserveBody(url);
    }
    getPDFReportModuleCategoryMenu(reportOrientation, reportType, dataSource, numRequiredSecurities = null) {
        const queryParams = {
            orientation: reportOrientation,
            dataSource,
        };
        if (numRequiredSecurities !== null) {
            queryParams.numRequiredSecurities = String(numRequiredSecurities);
        }
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.MODULE_MENU, { reportType }, queryParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getPDFReport(reportId, reportOrientation = null) {
        let queryParams = {};
        if (reportOrientation) {
            queryParams = { reportOrientation };
        }
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PDF_REPORT, { reportId }, queryParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    postPDFReport(postParams) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.COLLECTION;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    putPDFReport(reportId, putParams) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PDF_REPORT, { reportId });
        return this.ajaxService.putJsonDataObserveBody(url, putParams);
    }
    generatePDFReport(reportId, postParams) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PDF_REPORT, { reportId });
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    generateUnsavedPDFReport(generationParams, reportParams, modules, filterLegacy = false) {
        const queryParams = filterLegacy ? { filterLegacy } : {};
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.UNSAVED_REPORT_GENERATION, {}, queryParams);
        return this.ajaxService.postJsonDataObserveBody(url, {
            generationParams,
            reportParams,
            modules,
        });
    }
    deletePDFReport(reportId) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PDF_REPORT, { reportId });
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    duplicatePDFReport(reportId, newName, targetFolder) {
        const urlParams = { reportId };
        const postParams = { name: newName, targetFolder };
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.DUPLICATE, urlParams);
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    getPDFReportsList(getParams) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.LIST;
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    getPDFReportTemplates() {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.TEMPLATES;
        return this.ajaxService.getDataObserveBody(url);
    }
    validatePDFReportModule(reportType, module) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.VALIDATE_MODULE, { reportType });
        return this.ajaxService.postJsonDataObserveBody(url, module);
    }
    validateReportSecurityList(reportId, securityListName, securityGroup, isOnePageReport = false) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.VALIDATE_SECURITY_LIST, {
            reportId,
            securityListName,
            securityGroup,
            isOnePageReport,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
    validateReportSecurities(reportId, modules, security_ids, securitylist_group) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.VALIDATE_SECURITIES, {
            reportId,
        });
        return this.ajaxService.postJsonDataObserveBody(url, { security_ids, securitylist_group, modules });
    }
    reorientPDFReport(postParams) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.REORIENT_PDF;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    getWizardStepsFromModules(modules, reportType, reportOrientation, includesSections) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.WIZARD_STEPS;
        return this.ajaxService.postJsonDataObserveBody(url, {
            reportType,
            reportOrientation,
            modules,
            includesSections,
        });
    }
    validateDataSource(reportParams, modules) {
        // We do not care about the success responses, only the error responses
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.VALIDATE_DATA_SOURCE);
        return this.ajaxService.postJsonDataObserveBody(url, {
            reportParams,
            modules,
        });
    }
}
CustomPDFReportService.ɵfac = function CustomPDFReportService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CustomPDFReportService)(i0.ɵɵinject(i1.AccountsService), i0.ɵɵinject(i2.AjaxService), i0.ɵɵinject(i3.UrlsService)); };
CustomPDFReportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CustomPDFReportService, factory: CustomPDFReportService.ɵfac, providedIn: 'root' });
